module.exports = __webpack_public_path__ + "files/768bab3604e387655fc4cfbd55ecc0a1.png";